import { render, staticRenderFns } from "./MessageTypesFilter.vue?vue&type=template&id=7110b8fc&"
import script from "./MessageTypesFilter.vue?vue&type=script&lang=ts&"
export * from "./MessageTypesFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports